module.exports = __webpack_public_path__ + "img/logo-solency.585eb67c.svg";